var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo top-0 left-0 z-50 transition-all w-32",class:{'hidden': _vm.shadow}},[_c('inertia-link',{attrs:{"href":_vm.route('web.home')}},[_c('tis-logo',{attrs:{"width":"200","height":"auto"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }